import {useEffect, useState} from "react";
import AddNewRoleImage from "../../assets/media/svg/undraw_add_files.svg"
import axios from "axios";
import swal from 'sweetalert';
import CreateRoleModal from "./CreateRoleModal";
import UpdateRoleModal from "./UpdateRoleModal";


const Roles = () => {

    const [roles, setRoles] = useState([]);
    const [createRoleModal, setCreateRoleModal] = useState(false);
    const [modalTriggers, setModalTriggers] = useState([]);
    const [triggerRoles, setTriggerRoles] = useState(0);

    useEffect(() => {
        axios.get('roles').then(response => {
            setRoles(response.data.roles)
        })

    }, [triggerRoles])

    useEffect(() => {
        let tempArray = [];

        roles.map((role,index) => {
           tempArray.push(false)
        })

        setModalTriggers(tempArray)
    }, [roles])

    const handleModalTrigger = (index) => {
        setModalTriggers(modalTriggers.map((trigger, triggerIndex) => {
            return triggerIndex === index
        }))
    }

    const deleteRole = (id, name) => {
        swal({
            title: "Are you sure?",
            text: 'If you DELETE role "' + name + '", the users with the given role may revoke permissions; Do you want to proceed?',
            icon: "warning",
            buttons: true,
            dangerMode: true,
            buttons: ["No", "Yes"],
            confirm: {
                text: "Yes",
                value: true,
                visible: true,
                className: "",
                closeModal: true
            }
        }).then((result) => {
            if (result == true) {
                axios.delete('roles/' + id).then(function (res) {
                    if (res.status === 200) {
                        swal('The role "' + name + '" has been deleted!', {
                            icon: "success",
                        });
                        setTriggerRoles(id);
                        return true;
                    } else {
                        return false;
                    }
                }).catch(function (error) {
                    console.log(error);
                });
            }
        });
    }

    return (
        <div className="content d-flex flex-column flex-column-fluid" id="kt_content">
            <div id="kt_content_container" className="container-fluid">
                <div className="row row-cols-1 row-cols-md-2 row-cols-xl-3 g-5 g-xl-9">
                    {
                        roles.map((role, index) => (
                            <div key={index} className="col-md-4">
                                <div className="card card-flush h-md-100 border-0 box-shadow-4">
                                    <div className="card-header">
                                        <div className="card-title">
                                            <h2>{role.name}</h2>
                                        </div>
                                        <div className="float-right pt-5">
                                            <button
                                             className="btn btn-danger box-shadow-4"
                                             type="button"
                                             onClick={()=>{deleteRole(role?.id, role?.name)}}
                                             >
                                                <i className="far fa-trash-alt fs-5 mr-2"></i>
                                                <span>Delete</span>
                                            </button>
                                        </div>
                                    </div>

                                    <div className="card-body pt-1">
                                        <div className="fw-bolder text-gray-600 mb-5">Total users with this role: {role.users_count ?? 0}</div>
                                        <div className="d-flex flex-column text-gray-600">
                                            {
                                                role.name === "Super Admin"
                                                ?
                                                    <div className="d-flex align-items-center py-2">
                                                        <span className="bullet bg-primary me-3"></span>
                                                        All Permissions
                                                    </div>
                                                :
                                                    role.permissions.length > 0
                                                    ?
                                                        role.permissions.map((permission, index) => (
                                                            <div key={index} className="d-flex align-items-center py-2">
                                                                <span className="bullet bg-primary me-3"></span>
                                                                {
                                                                    permission.name
                                                                }
                                                            </div>
                                                        ))
                                                    :
                                                        <div key={index} className="d-flex align-items-center py-2">
                                                            <span className="bullet bg-primary me-3"></span>
                                                            No Permissions
                                                        </div>

                                            }
                                        </div>
                                    </div>

                                    <div className="card-footer flex-wrap pt-0">
                                        <a href="#"
                                           className="btn btn-light btn-active-primary my-1 me-2">
                                            View Role
                                        </a>
                                        <button onClick={() => handleModalTrigger(index)} type="button" className="btn btn-light btn-active-light-primary my-1"
                                                data-bs-toggle="modal" data-bs-target="#kt_modal_update_role">
                                            Edit Role
                                        </button>
                                    </div>
                                </div>

                                <UpdateRoleModal
                                    role={role}
                                    updateRoleModal={modalTriggers[index]}
                                    setUpdateRoleModal={setModalTriggers}
                                    setRoles={setRoles}
                                    index={index}
                                />
                            </div>

                        ))
                    }
                    <div className="ol-md-4">
                        <div
                          className="card h-md-100 border-0 box-shadow-4 cursor-pointer add-new-role-card"
                          onClick={() => setCreateRoleModal(true)}
                        >
                            <div className="card-body d-flex flex-center">
                                <button type="button" className="btn btn-clear d-flex flex-column flex-center"
                                        data-bs-toggle="modal" data-bs-target="#kt_modal_add_role">
                                    <img src={AddNewRoleImage} alt=""
                                         className="mw-100 mh-150px mb-7"
                                    />
                                    <div className="fw-bolder fs-3 text-gray-600">Add New Role</div>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                <CreateRoleModal
                    createRoleModal={createRoleModal} setCreateRoleModal={setCreateRoleModal} setRoles={setRoles}
                />

            </div>
        </div>
    )
}

export default Roles;